import React from "react";
import { applySpec } from "ramda";
import { connect } from "react-redux";
import { Tab, Tabs } from "react-toolbox/lib/tabs";
import EditMediaGeneralTab from "edit-media/components/EditMediaGeneralTab";
import EditMediaDescriptionTab from "edit-media/components/EditMediaDescriptionTab";
import EditMediaInfoTab from "edit-media/components/EditMediaInfoTab";
import EditMediaContributorsTab from "edit-media/components/EditMediaContributorsTab";
import { selectActiveTab } from "edit-media/redux/editMediaActions";
import {
  getEditMediaActiveTabIndex,
  getEditMediaItemType,
} from "common/selectors";
import styles from "edit-media/components/EditMediaTabsTheme.css";

const EditMediaTabs = ({ activeTabIndex, mediaItemType, onTabChange }) => (
  <Tabs theme={styles} index={activeTabIndex} onChange={onTabChange}>
    <Tab label="General Info">
      <EditMediaGeneralTab />
    </Tab>
    <Tab label="Description">
      <EditMediaDescriptionTab />
    </Tab>
    <Tab label={mediaItemType + " Info"}>
      <EditMediaInfoTab />
    </Tab>
    <Tab label="Contributors">
      <EditMediaContributorsTab />
    </Tab>
  </Tabs>
);

const mapStateToProps = applySpec({
  activeTabIndex: getEditMediaActiveTabIndex,
  mediaItemType: getEditMediaItemType,
});

const mapDispatchToProps = dispatch => ({
  onTabChange: index => dispatch(selectActiveTab(index)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EditMediaTabs);
